import { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FolderOpen, ArrowSquareOut } from '@phosphor-icons/react';
import DashboardLayout from '../components/DashboardLayout';
import API_URL from '../config';

export default function DrivePage() {
  const [folderData, setFolderData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFolder();
  }, []);

  const fetchFolder = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/client/drive-folder`);
      setFolderData(response.data);
    } catch (error) {
      console.error('Error fetching folder:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <div className="w-8 h-8 border-2 border-[#ffd100] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="max-w-3xl mx-auto" data-testid="drive-page">
        {/* Header */}
        <div className="mb-8">
          <p className="label-uppercase mb-1" style={{ color: '#1d57a5' }}>Your Files</p>
          <h1 className="text-3xl font-bold tracking-tight" style={{ color: '#141b4d' }}>
            Documents
          </h1>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-6"
        >
          {/* Main card */}
          <div className="card-swiss text-center py-12">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#f2e9db' }}>
              <FolderOpen weight="duotone" className="w-10 h-10" style={{ color: '#141b4d' }} />
            </div>
            
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#141b4d' }}>
              Your Client Folder
            </h2>
            
            <p className="max-w-md mx-auto mb-8" style={{ color: '#9a9488' }}>
              This is where we store all the documents related to your trademark matters — comprehensive search reports, specimens, application filing receipts, office action responses, and more.
            </p>

            {folderData?.has_folder ? (
              <a
                href={folderData.folder_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center justify-center gap-2 w-full sm:w-auto text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4"
                data-testid="open-drive-folder-btn"
              >
                <FolderOpen weight="bold" className="w-5 h-5" />
                Open in Google Drive
                <ArrowSquareOut weight="bold" className="w-5 h-5" />
              </a>
            ) : (
              <div className="callout-box max-w-md mx-auto">
                <p className="text-sm" style={{ color: '#9a9488' }}>
                  Your document folder is being set up. Once ready, you'll be able to access all your files here.
                </p>
              </div>
            )}
          </div>

          {/* Info */}
          <div className="callout-box">
            <p className="text-sm" style={{ color: '#9a9488' }}>
              <strong style={{ color: '#141b4d' }}>What you'll find in your folder:</strong> Comprehensive trademark search reports, filing specimens, USPTO application receipts, office action documents, registration certificates, and any other materials related to your matters.
            </p>
          </div>
        </motion.div>
      </div>
    </DashboardLayout>
  );
}
